import React, { useEffect, useState } from "react";
import { Row, Col, Card, Switch } from "antd";
import userProfile from "../../../assets/images/profile/reminder.png";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { resendEmailReminderApi } from "../../../services/profile.service";

const EmailReminder: React.FC = () => {
  const [reminderEnabled, setReminderEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state?.profile);
  useEffect(() => {
    if (profile?.skincare_email_reminder !== undefined) {
      setReminderEnabled(profile?.skincare_email_reminder === 1);
    }
  }, [profile?.skincare_email_reminder]);

  const handleToggleChange = (checked: boolean) => {
    setReminderEnabled(checked);
  };

  const resendReminderSetting = (checked: boolean) => {
    setReminderEnabled(checked);
    const data = {
      skincare_email_reminder: checked ? 1 : 0,
    };
    setLoading(true);
    dispatch(
      resendEmailReminderApi({
        data,
        finalCallback: () => {
          // Optional: Add any final callback logic here
          setLoading(false);
        },
        successCallback: (response: any) => {
          // Optional: Add any success callback logic here
          setReminderEnabled(response?.skincare_email_reminder === 1);
          console.log("Email reminder setting updated:", response);
        },
        failureCallback: () => {
          // Optional: Handle unauthenticated case here
        },
      })
    );
  };

  return (
    <div className="email-reminder-container email-reminder">
      <Card>
        <Row gutter={[10, 10]} align="middle">
          {/* Profile Image */}
          <Col xs={24} sm={6} md={3} style={{ textAlign: "center" }}>
            <img
              src={userProfile}
              alt="Profile"
              style={{ width: "100%", borderRadius: "50%" }}
            />
          </Col>

          {/* Text Content */}
          <Col xs={24} sm={12} md={18}>
            <h1 className="reminder-title">Say hello to Joy!</h1>
            <p className="content">
              Joy sends simple email routine reminders every day so you know
              exactly what skincare to use. You can turn reminders on or off as
              you prefer. She is a virtual assistant sending automated,
              expert‑tuned reminders.
            </p>
          </Col>

          <Col xs={24} sm={6} md={3} style={{ textAlign: "center" }}>
            <Switch
              checked={reminderEnabled}
              onChange={resendReminderSetting}
              checkedChildren="On"
              unCheckedChildren="Off"
              loading={loading}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default EmailReminder;
